import { useState } from 'react';
import api from '../../axios';
import GuestLayout from '../../Layouts/GuestLayout';
import InputLabel from '../../Components/InputLabel';
import TextInput from '../../Components/TextInput';
import PrimaryButton from '../../Components/PrimaryButton';
import InputError from '../../Components/InputError';
import { Button } from '../../shadcn/ui/button';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('');
  const [errors, setErrors] = useState({});

  const submit = async (e) => {
    e.preventDefault();
    try {
      setErrors({}); // Clear errors before submitting
      await api.post('/forgot-password', { email });
      setStatus('Ο σύνδεσμος επαναφοράς κωδικού πρόσβασης έχει σταλεί στο email σας.');
    } catch (err) {
      setStatus(''); // Clear the success message if an error occurs
      setErrors(err.response.data.errors || {});
    }
  };

  return (
    <GuestLayout>
          <div className="flex flex-col items-center justify-center">

      <h1 className="text-2xl font-bold mb-6 text-center">Ξέχασα τον κωδικό πρόσβασης</h1>
      <form onSubmit={submit}>
        <div>
          <InputLabel htmlFor="email" value="Email" />
          <TextInput
            id="email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <InputError message={errors.email} />
        </div>

        {/* Display either the success or error message */}
        {status && <p className="text-sm text-green-600 mt-4">{status}</p>}

        <div className="mt-4">
          <Button type="submit">Αποστολή συνδέσμου επαναφοράς κωδικού πρόσβασης</Button>
        </div>
      </form>
      </div>
    </GuestLayout>
  );
}
